
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n'; // Import i18n configuration

// Wait for DOM content to be loaded before mounting React
document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById("root");
  
  if (rootElement) {
    console.log('[DEBUG] Main: Creating React root for main application');
    createRoot(rootElement).render(<App />);
  } else {
    console.log('[DEBUG] Main: Root element not found, this is expected when running as web component only');
  }
});

// Import and register the web component
import './components/web-components/CostCalculatorElement';
